<template>
  <div style="width:100%;float:left;">
    <div class="col-lg-6 col-md-6 float-left">
      <CCard>
          <CCardHeader>Top Sold Styles</CCardHeader>
          <CCardBody>
            <div class="all" v-if="!loading && data">
              <CDataTable
                :items="data.styles"
                :fields="['style', 'total_quantity', 'total_amount']"
              >
                <template #total_quantity="{item}">
                  <td>
                    {{Math.abs(item.total_quantity)}}
                  </td>
                </template>
                <template #total_amount="{item}">
                  <td>
                    {{Math.abs(item.total_amount).toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD',
                    })}}
                  </td>
                </template>
              </CDataTable>
            </div>
            <small-loader v-else></small-loader>
          </CCardBody>
      </CCard>
    </div>
    <div class="col-lg-6 col-md-6 float-left">
      <CCard>
          <CCardHeader>Top Sold Style + Colors</CCardHeader>
          <CCardBody>
            <div class="all" v-if="!loading && data">
              <CDataTable
                :items="data.style_colors"
                :fields="['style_color', 'total_quantity', 'total_amount']"
              >
                <template #total_quantity="{item}">
                  <td>
                    {{Math.abs(item.total_quantity)}}
                  </td>
                </template>
                <template #total_amount="{item}">
                  <td>
                    {{Math.abs(item.total_amount).toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD',
                    })}}
                  </td>
                </template>
              </CDataTable>
            </div>
            <small-loader v-else></small-loader>
          </CCardBody>
      </CCard>
    </div>
  </div>
  </template>
  <script>
  var methods = {}

  methods.getTopItems = function () {
    this.loading = true
    const postData = {
        customer: this.customer_selected
    }
    axios.post(this.$apiAdress + '/api/reports/getTopItems?token=' + localStorage.getItem('api_token'), postData).then(response => {
        console.log(response)
        this.data = response.data
        this.loading = false
    })
  }
  
  export default {
    // ===Component name
    name: "CustomerTopItems",
    // ===Props passed to component
    props: ['customer_selected'],
    // ===Components used by this component
    components: {
  
    },
    // ====component Data properties
    data(){
        return{
            data: null,
            loading: true
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
        this.getTopItems()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
  }
  </script>
  <!-- styles -->
  <!-- adding scoped attribute will apply the css to this component only -->
  <style scoped></style>
  